import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useEffect, useState } from "react";
import { MdPrint, MdRemoveRedEye } from "react-icons/md";
import Modal from "react-modal";
import { toast } from "react-toastify";
import OrderDetails from "./OrderDetails";
import { adminApiService } from "../../../services/api";
import { Dialog } from "@headlessui/react";

Modal.setAppElement("#root");

export default function OrdersTable() {
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const printRef = React.useRef(null);
  const ordersPerPage = 10;

  const [orderModalIsOpen, setOrderModalIsOpen] = useState(false);
  const [invoiceModalIsOpen, setInvoiceModalIsOpen] = useState(false);
  const [selectedOrderItems, setSelectedOrderItems] = useState(null);
  const [selectedOrderUser, setSelectedOrderUser] = useState(null);
  const [selectedOrderData, setSelectedOrderData] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const [isCourierDialogOpen, setIsCourierDialogOpen] = useState(false);
  const [selectedCourier, setSelectedCourier] = useState("");
  const [selectedOrderForCourier, setSelectedOrderForCourier] = useState(null);
  const [couriers] = useState([
    { id: "pathao", name: "Pathao" },
    { id: "redx", name: "RedX" },
    { id: "steadfast", name: "Steadfast" },
    { id: "e-courier", name: "E-Courier" },
  ]);

  const handleOrderStatusChange = async (orderId, newStatus) => {
    if (newStatus === "hand over to courier") {
      const order = orders.find((o) => o.id === orderId);
      setSelectedOrderForCourier(order);
      setIsCourierDialogOpen(true);
      return;
    }

    try {
      // Update the order status
      const response = await adminApiService.updateOrderStatus(orderId, {
        order_status: newStatus,
      });

      if (!response.ok) throw new Error("Failed to update order status.");
      const updatedOrder = await response.json();

      // Update the local state with the new order status
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.id === updatedOrder.id
            ? { ...order, order_status: updatedOrder.order_status }
            : order
        )
      );

      fetchOrders();
      toast.success("Order status updated successfully.");
    } catch (error) {
      console.error("Error updating order status:", error);
      toast.error("Error updating order status.");
    }
  };

  const handleCourierSelection = async () => {
    if (!selectedCourier) {
      toast.error("Please select a courier");
      return;
    }

    try {
      // First update the order status
      const response = await adminApiService.updateOrderStatus(
        selectedOrderForCourier.id,
        { order_status: "hand over to courier" }
      );

      if (!response.ok) throw new Error("Failed to update order status.");
      const updatedOrder = await response.json();

      // Update the local state with the new order status
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.id === updatedOrder.id
            ? { ...order, order_status: updatedOrder.order_status }
            : order
        )
      );

      // Then handle the courier handover
      await handleHandoverToCourier(
        selectedOrderForCourier.id,
        selectedCourier
      );

      // Close the dialog and reset states
      setIsCourierDialogOpen(false);
      setSelectedCourier("");
      setSelectedOrderForCourier(null);

      fetchOrders();
      toast.success("Order handed over to courier successfully.");
    } catch (error) {
      console.error("Error in courier handover process:", error);
      toast.error("Error in courier handover process");
    }
  };

  const handleHandoverToCourier = async (orderId, courierType) => {
    try {
      const selectedOrder = orders.find((order) => order.id === orderId);

      if (!selectedOrder) {
        throw new Error("Order not found.");
      }

      const payload = {
        recipient_name: `${selectedOrder.User.first_name} ${selectedOrder.User.last_name}`,
        recipient_mobile: selectedOrder.shipping_user_mobile,
        recipient_city: selectedOrder.shipping_user_city,
        recipient_area: selectedOrder.shipping_user_area,
        recipient_thana: selectedOrder.shipping_user_thana,
        recipient_address: selectedOrder.shipping_user_address,
        payment_method: selectedOrder.payment_method,
        recipient_zip: selectedOrder.shipping_user_zip_code,
        order_id: selectedOrder.id,
        courier_type: courierType,
      };

      const response = await adminApiService.handoverToCourier(
        orderId,
        payload
      );

      if (!response.ok) throw new Error("Failed to handover to courier.");
      const data = await response.json();
      console.log("Handover to courier successful:", data);
    } catch (error) {
      console.error("Error handing over to courier:", error);
      throw error;
    }
  };

  // New state for payment status filter ("all", "paid", "unpaid")
  const [paymentFilter, setPaymentFilter] = useState("all");

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await adminApiService.getAllOrders();
      if (!response.ok) throw new Error("Failed to fetch orders.");
      const data = await response.json();

      // Sort orders in descending order by created_at date
      const sortedOrders = data.allOrders.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
      setOrders(sortedOrders);
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("No Orders found.");
    }
  };

  const openOrderModal = async (orderId) => {
    try {
      const response = await adminApiService.getOrderById(orderId);
      if (!response.ok) throw new Error("Failed to fetch order details.");
      const data = await response.json();
      console.log("Order details data:", data);

      // Assume your API returns { orderItems: [...] }
      setSelectedOrderUser(data.user);
      setSelectedOrderItems(data.orderItems);
      setSelectedOrderData(data.order);
      setOrderModalIsOpen(true);
      setSelectedOrderId(orderId);
    } catch (error) {
      console.error("Error fetching order:", error);
      toast.error("Error fetching order details.");
    }
  };

  console.log(selectedOrderData);

  const openInvoiceModal = async (orderId) => {
    try {
      const response = await adminApiService.getOrderById(orderId);
      if (!response.ok) throw new Error("Failed to fetch order details.");
      const data = await response.json();
      console.log("Order details data:", data);

      // Assume your API returns { orderItems: [...] }
      setSelectedOrderUser(data.user);
      setSelectedOrderItems(data.orderItems);
      setSelectedOrderData(data.order);
      setInvoiceModalIsOpen(true);
    } catch (error) {
      console.error("Error fetching order:", error);
      toast.error("Error fetching order details.");
    }
  };

  const closeOrderModal = () => {
    setOrderModalIsOpen(false);
    setSelectedOrderItems(null);
  };

  const closeInvoiceModal = () => {
    setInvoiceModalIsOpen(false);
    setSelectedOrderItems(null);
  };

  // Handle payment status filter change
  const handlePaymentFilterChange = (e) => {
    setPaymentFilter(e.target.value);
    setCurrentPage(1);
  };

  const handlePrint = async (orderId) => {
    try {
      const element = printRef.current;
      if (!element) {
        return;
      }

      const canvas = await html2canvas(element, {
        scale: 2,
      });
      const data = canvas.toDataURL("image/png");

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
      });

      const imgProperties = pdf.getImageProperties(data);
      const pdfWidth = pdf.internal.pageSize.getWidth();

      const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

      pdf.addImage(data, "PNG", 0, 0, pdfWidth, pdfHeight);

      const filename = `invoice#${selectedOrderId}.pdf`;

      pdf.save(filename);
    } catch (error) {
      console.error("Error downloading invoice:", error);
      toast.error("Error downloading invoice.");
    }
  };

  const filteredOrders = orders.filter((order) => {
    // Payment status filter
    const paymentMatch =
      paymentFilter === "all" ||
      order.payment_status.toLowerCase() === paymentFilter;

    // Date filter
    let dateMatch = true;
    if (fromDate || toDate) {
      const orderDate = new Date(order.created_at).toISOString().slice(0, 10);
      if (fromDate && toDate) {
        dateMatch = orderDate >= fromDate && orderDate <= toDate;
      } else if (fromDate) {
        dateMatch = orderDate >= fromDate;
      } else if (toDate) {
        dateMatch = orderDate <= toDate;
      }
    }

    const searchMatch =
      order.id.toString().includes(searchQuery) ||
      `${order.User.first_name} ${order.User.last_name}`
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      order.transaction_id.toLowerCase().includes(searchQuery.toLowerCase()) ||
      order.payment_method.toLowerCase().includes(searchQuery.toLowerCase()) ||
      order.User.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      order.shipping_user_mobile.includes(searchQuery);

    return paymentMatch && dateMatch && searchMatch;
  });

  // Pagination for filtered orders
  const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = filteredOrders.slice(
    indexOfFirstOrder,
    indexOfLastOrder
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      {/* Header with payment and date filter */}
      <div className="mb-10 rounded-lg bg-white p-6 shadow-sm">
        <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-center sm:gap-4">
          {/* Title */}

          <div></div>
          {/* Filters */}
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-6">
            {/* Search */}
            <div className="relative w-full sm:w-56">
              <input
                type="text"
                placeholder="Search orders..."
                className="w-full rounded-lg border border-gray-200 px-4 py-2.5 pl-10 text-sm shadow-sm transition-all focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <svg
                className="absolute left-3 top-3 h-4 w-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>

            {/* Date Range */}
            <div className="flex items-center gap-2">
              <div className="flex items-center">
                <label
                  htmlFor="fromDate"
                  className="mr-2 text-sm text-gray-600"
                >
                  From:
                </label>
                <input
                  type="date"
                  id="fromDate"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  className="rounded-lg border border-gray-200 px-3 py-2 text-sm shadow-sm transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <span className="text-gray-400">-</span>
              <div className="flex items-center">
                <label htmlFor="toDate" className="mr-2 text-sm text-gray-600">
                  To:
                </label>
                <input
                  type="date"
                  id="toDate"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  className="rounded-lg border border-gray-200 px-3 py-2 text-sm shadow-sm transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            {/* Payment Filter */}
            <div className="flex items-center">
              <label
                htmlFor="paymentFilter"
                className="mr-2 text-sm text-gray-600"
              >
                Status:
              </label>
              <select
                id="paymentFilter"
                value={paymentFilter}
                onChange={handlePaymentFilterChange}
                className="rounded-lg border border-gray-200 px-3 py-2 text-sm shadow-sm transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="all">All</option>
                <option value="paid">Paid</option>
                <option value="unpaid">Unpaid</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Orders Table */}
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-left text-sm text-gray-500">
          <thead className="bg-primary text-xs uppercase text-white">
            <tr>
              <th className="px-6 py-3">Order ID</th>
              <th className="px-6 py-3">Customer Name</th>
              <th className="px-6 py-3">Total Amount</th>
              <th className="px-6 py-3">Discount</th>
              <th className="px-6 py-3">Shipping Cost</th>
              <th className="px-6 py-3">Final Amount</th>
              <th className="px-6 py-3">Payment Method</th>
              <th className="px-6 py-3">Order Type</th>
              <th className="px-6 py-3">Order Status</th>
              <th className="px-6 py-3">Payment Status</th>
              <th className="px-6 py-3">Created At</th>
              <th className="px-6 py-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentOrders && currentOrders.length > 0 ? (
              currentOrders.map((order) => (
                <tr key={order.id} className="border-b bg-white">
                  <td className="px-6 py-4 text-navy-900">{order.id}</td>

                  <td className="px-6 py-4 text-base text-navy-900">
                    {order.User.first_name} {order.User.last_name}
                  </td>
                  <td className="px-6 py-4 text-base text-navy-900">
                    {order.total_amount} TK
                  </td>
                  <td className="px-6 py-4 text-base text-navy-900">
                    {order.discount} TK
                  </td>
                  <td className="px-6 py-4 text-base text-navy-900">
                    {order.shipping_cost} TK
                  </td>
                  <td className="px-6 py-4 text-base text-navy-900">
                    {order.final_amount} TK
                  </td>
                  <td className="px-6 py-4 text-base text-navy-900">
                    {order.payment_method}
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`rounded-full px-3 py-1 text-xs font-medium ${
                        order.directorder
                          ? "bg-blue-100 text-blue-600"
                          : "bg-purple-100 text-purple-600"
                      }`}
                    >
                      {order.directorder ? "Direct" : "User"}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <select
                      value={order.order_status}
                      onChange={(e) =>
                        handleOrderStatusChange(order.id, e.target.value)
                      }
                      className="rounded-md border border-gray-300 p-2 text-sm text-navy-900 shadow-sm transition duration-150 ease-in-out focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="pending">Pending</option>
                      <option value="processing">Processing</option>
                      <option value="ready to ship">Ready to Ship</option>
                      <option value="hand over to courier">
                        Hand Over to Courier
                      </option>
                      <option value="completed">completed</option>
                      <option value="canceled">cancel</option>
                    </select>
                  </td>
                  <td className="px-6 py-4 text-green-600">
                    {order.payment_status}
                  </td>
                  <td className="px-6 py-4 text-base text-navy-900">
                    {new Date(order.created_at).toLocaleString()}
                  </td>
                  <td className="px-4 py-4">
                    <button
                      aria-label="View Order"
                      className="p-1 text-2xl text-navy-600 hover:bg-gray-100"
                      onClick={() => openOrderModal(order.id)}
                    >
                      <MdRemoveRedEye />
                    </button>
                    <button
                      aria-label="Download Invoice"
                      className="p-1 text-2xl text-navy-600 hover:bg-gray-100"
                      onClick={() => openInvoiceModal(order.id)}
                    >
                      <MdPrint />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="flex w-full items-center justify-center ">
                <td className="mt-10  p-5 text-center text-xl text-navy-900">
                  No Orders Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="mt-4 flex justify-center">
        <nav className="flex items-center space-x-2">
          <button
            onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
            className={`rounded px-3 py-1 ${
              currentPage === 1 ? "bg-gray-300" : "bg-primary text-white"
            }`}
          >
            Previous
          </button>
          {[...Array(totalPages)].map((_, index) => {
            const pageNumber = index + 1;
            return (
              <button
                key={pageNumber}
                onClick={() => paginate(pageNumber)}
                className={`rounded px-3 py-1 ${
                  currentPage === pageNumber
                    ? "bg-primary text-white"
                    : "bg-blue-200 text-primary"
                }`}
              >
                {pageNumber}
              </button>
            );
          })}
          <button
            onClick={() =>
              currentPage < totalPages && setCurrentPage(currentPage + 1)
            }
            disabled={currentPage === totalPages}
            className={`rounded px-3 py-1 ${
              currentPage === totalPages
                ? "bg-gray-300"
                : "bg-primary text-white"
            }`}
          >
            Next
          </button>
        </nav>
      </div>

      {/* Order Details Modal */}
      <OrderDetails
        isOpen={orderModalIsOpen}
        onRequestClose={closeOrderModal}
        selectedOrderUser={selectedOrderUser}
        selectedOrderData={selectedOrderData}
        selectedOrderItems={selectedOrderItems}
        selectedOrderID={selectedOrderId}
      />

      {/* Invoice Modal */}
      <Modal
        isOpen={invoiceModalIsOpen}
        onRequestClose={closeInvoiceModal}
        contentLabel="Order Details"
        className="text-black relative z-50 mx-auto max-w-screen-lg overflow-y-auto rounded-lg bg-white p-8 shadow-2xl"
        overlayClassName="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
        style={{
          content: {
            maxHeight: "90vh",
            width: "90%",
            maxWidth: "800px",
          },
        }}
      >
        {selectedOrderUser && (
          <>
            <div
              ref={printRef}
              className="mx-auto my-10 max-w-3xl border border-gray-300 p-6 text-sm text-gray-800 shadow-sm"
            >
              {/* Invoice Header */}
              <div className="mb-6 text-center">
                <h1 className="text-2xl font-bold uppercase tracking-wide">
                  Invoice
                </h1>
              </div>

              {/* Company / Seller Info & Invoice Details */}
              <div className="mb-4 flex justify-between">
                <div>
                  <img src="/logo.avif" className="mb-2 w-28" alt="" />

                  <p className="text-xs">Phone: 09609006006</p>
                </div>
                <div className="text-right">
                  <p className="text-sm">
                    Date: {new Date().toLocaleDateString()}
                  </p>
                  <p className="text-sm font-semibold">
                    Invoice No: {selectedOrderId}
                  </p>
                </div>
              </div>

              {/* Customer Info */}
              <div className="mb-4 mt-5 flex justify-between">
                <div className="w-1/2">
                  <p className="text-sm">
                    <span className="font-semibold">Customer Name:</span>{" "}
                    {selectedOrderUser.first_name} {selectedOrderUser.last_name}
                  </p>
                  <p className="text-sm">
                    <span className="font-semibold">Email:</span>{" "}
                    {selectedOrderUser.email}
                  </p>
                  <p className="text-sm">
                    <span className="font-semibold">Phone:</span>{" "}
                    {selectedOrderData.shipping_user_mobile}
                  </p>
                  <p className="mt-2 text-sm">
                    <span className="font-semibold">Address:</span>{" "}
                    {selectedOrderData.shipping_user_address}
                  </p>
                  <p className="text-sm">
                    <span className="font-semibold">Area:</span>{" "}
                    {selectedOrderData.shipping_user_area}
                  </p>
                  <p className="text-sm">
                    <span className="font-semibold">City:</span>{" "}
                    {selectedOrderData.shipping_user_city}
                  </p>
                  <p className="mt-2 text-sm">
                    <span className="font-semibold">Payment Method:</span> Cash
                    On Delivery
                  </p>
                </div>
              </div>

              {/* Table Header */}
              <table className="mb-4 w-full border-collapse border border-gray-300">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border border-gray-300 px-2 py-1 text-left">
                      SL
                    </th>
                    <th className="border border-gray-300 px-2 py-1 text-left">
                      Product Image
                    </th>
                    <th className="border border-gray-300 px-2 py-1 text-left">
                      Product Name
                    </th>

                    <th className="border border-gray-300 px-2 py-1 text-right">
                      Price
                    </th>
                    <th className="border border-gray-300 px-2 py-1 text-right">
                      Discount
                    </th>
                    <th className="border border-gray-300 px-2 py-1 text-center">
                      QTY
                    </th>
                    <th className="border border-gray-300 px-2 py-1 text-right">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {selectedOrderItems && selectedOrderItems.length > 0 ? (
                    selectedOrderItems.map((item, index) => (
                      <tr key={item.id}>
                        <td className="border border-gray-300 px-2 py-1">
                          {index + 1}
                        </td>
                        <td className="border border-gray-300 px-2 py-1">
                          <img
                            src={adminApiService.getProductImageUrl(
                              item.product_images[0]
                            )}
                            alt=""
                            className="h-16 w-16"
                          />
                        </td>
                        <td className="border border-gray-300 px-2 py-1">
                          {item.name}
                        </td>

                        <td className="border border-gray-300 px-2 py-1 text-right">
                          {item.price_customer}
                        </td>
                        <td className="border border-gray-300 px-2 py-1 text-right">
                          {item.product_discount}
                        </td>
                        <td className="border border-gray-300 px-2 py-1 text-center">
                          {item.quantity}
                        </td>
                        <td className="border border-gray-300 px-2 py-1 text-right">
                          {(item.price_customer - item.product_discount) *
                            item.quantity}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="py-4 text-center">
                        No items found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Totals Section */}
              <div className="mb-4 flex justify-end">
                <div className="w-full sm:w-1/2 md:w-1/3">
                  <div className="flex justify-between">
                    <span>Subtotal:</span>
                    <span>{selectedOrderData?.total_amount} TK</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Discount:</span>
                    <span>
                      {selectedOrderItems?.reduce(
                        (total, item) =>
                          total + item.product_discount * item.quantity,
                        0
                      )}{" "}
                      TK
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span>Delivery Charge:</span>
                    <span>{selectedOrderData?.shipping_cost} TK</span>
                  </div>
                  <hr className="my-2" />
                  <div className="flex justify-between font-semibold">
                    <span>Payable Amount:</span>
                    <span>{selectedOrderData?.final_amount} TK</span>
                  </div>
                </div>
              </div>

              {/* Disclaimer */}
              <div className="mt-5 flex flex-col gap-2">
                <p className="mb-2 text-center text-xs text-gray-500">
                  For warranty claim, please mention the invoice no. and keep
                  the box in a safe place. If you need assistance, please
                  contact 09677-460460.
                </p>
                <p className="text-center text-xs text-gray-500">
                  This is a computer-generated receipt and does not require
                  physical signature.
                </p>
              </div>
            </div>

            <div className="mt-10 flex w-full justify-end" id="printBTN">
              <button
                onClick={handlePrint}
                className="flex items-center justify-center gap-1 rounded-lg bg-primary px-4 py-1 text-lg text-white"
              >
                <MdPrint /> Print
              </button>
            </div>
          </>
        )}
      </Modal>

      {/* Courier Selection Dialog */}
      <Dialog
        open={isCourierDialogOpen}
        onClose={() => {
          setIsCourierDialogOpen(false);
          setSelectedCourier("");
          setSelectedOrderForCourier(null);
        }}
        className="relative z-50"
      >
        <div
          className="bg-black/80 fixed inset-0 backdrop-blur-sm"
          aria-hidden="true"
        />

        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="mx-auto max-w-sm rounded-lg bg-white p-6 shadow-xl">
            <Dialog.Title className="text-lg font-medium leading-6 text-gray-900">
              Select Courier Service
            </Dialog.Title>

            <div className="mt-4">
              <div className="space-y-2">
                {couriers.map((courier) => (
                  <div
                    key={courier.id}
                    className={`flex cursor-pointer items-center rounded-lg border p-3 ${
                      selectedCourier === courier.id
                        ? "border-primary bg-primary/10"
                        : "border-gray-200 hover:border-primary"
                    }`}
                    onClick={() => setSelectedCourier(courier.id)}
                  >
                    <input
                      type="radio"
                      checked={selectedCourier === courier.id}
                      onChange={() => setSelectedCourier(courier.id)}
                      className="h-4 w-4 border-gray-300 text-primary focus:ring-primary"
                    />
                    <label className="ml-3 text-sm font-medium text-gray-900">
                      {courier.name}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-6 flex justify-end space-x-3">
              <button
                type="button"
                className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                onClick={() => {
                  setIsCourierDialogOpen(false);
                  setSelectedCourier("");
                  setSelectedOrderForCourier(null);
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary/90"
                onClick={handleCourierSelection}
              >
                Confirm
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
}
